import React from 'react';
import useEnv from "../hooks/useEnv";


const Contact = () => {
  const envUrl = useEnv();
  
  const sendEmail = (event) => {
    event.preventDefault();
    // Get the form values
    const name = document.getElementById('name');
    const email = document.getElementById('email');
    const subject = document.getElementById('subject');
    const message = document.getElementById('message');

    fetch(`${envUrl}/webContactForm`, { //prod
    //fetch('http://127.0.0.1:5001/joltchat/us-central1/webContactForm', { //dev
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name: name.value, email: email.value, subject: subject.value, message: message.value})
        })
        .then(response => response.json())
        .then(data => {
            console.log('Email sent');
            // Redirect to the dashboard
            alert('Email sent');

            // Clear the form fields
            name.value = '';
            email.value = '';
            subject.value = '';
            message.value = '';
        })
        .catch(error => {
            console.error('Error:', error);
        });
  };

  return (
    <div id="contact" className="contact-us section py-10">
    <div className="container mx-auto">
      <div className="flex flex-wrap justify-center">
        <div className="w-full lg:w-1/2 text-center">
          <div className="section-heading wow fadeIn" data-wow-duration="1s" data-wow-delay="0.5s">
            <h6>Contact Us</h6>
            <h4>Get In Touch With Us <em>Now</em></h4>
            <div className="line-dec my-4 mx-auto w-24 h-1 bg-gray-300"></div>
          </div>
        </div>
        <div className="w-full wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.25s">
          <form id="contact" onSubmit={sendEmail}>
            <div className="flex flex-wrap">
              <div className="w-full">
                <div className="contact-dec">
                  <img src="assets/images/contact-us.jpeg" alt="" className="w-full h-auto" />
                </div>
              </div>
              <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
                <div id="map">
                  <iframe
                    title='map'
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d429155.33765594126!2d-117.43862177806625!3d32.824697644615476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d9530fad921e4b%3A0xd3a21fdfd15df79!2sSan%20Diego%2C%20CA!5e0!3m2!1sen!2sus!4v1708128724121!5m2!1sen!2sus"
                    width="100%"
                    height="500"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <div className="fill-form">
                  <div className="flex flex-wrap">
                    <div className="w-full lg:w-1/2 mb-4 lg:mb-0">
                      <fieldset>
                        <input type="text" name="name" id="name" placeholder="Name" autoComplete="on" required className="w-full p-2 border border-gray-300 rounded" />
                      </fieldset>
                      <fieldset>
                        <input type="text" name="email" id="email" pattern="[^ @]*@[^ @]*" placeholder="Your Email" required className="w-full p-2 border border-gray-300 rounded" />
                      </fieldset>
                      <fieldset>
                        <input type="text" name="subject" id="subject" placeholder="Subject" autoComplete="on" className="w-full p-2 border border-gray-300 rounded" />
                      </fieldset>
                    </div>
                    <div className="w-full lg:w-1/2 pl-5 contact-message">
                      <fieldset>
                        <textarea name="message" className="form-control w-full p-2 border border-gray-300 rounded" id="message" placeholder="Message" required></textarea>
                      </fieldset>
                    </div>
                    <div className="w-full">
                      <fieldset>
                        <button type="submit" id="form-submit" className="main-button bg-blue-500 text-white py-2 px-4 rounded">Send Message Now</button>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Contact;